import LanguageSwitchButton from "./language-switch-link";

const LanguageActions = {
	LanguageSwitchButton : LanguageSwitchButton
}

export default LanguageActions;